import { gsap } from '../global/gsap';

const initSearch = (element) => {
    const body = document.querySelector(".js-body");
    let rootUrl = "";
    if (body) {
        rootUrl = body.dataset.site ? body.dataset.site : "";
    }
    const searchToggle = document.querySelector(".js-search-button");
    const searchForm = element.querySelector(".js-search-form");
    const searchTags = element.querySelectorAll(".js-search-term");
    let searchInput = null;
    if (searchForm) {
        searchInput = searchForm.querySelector("input");
    }
    const searchList = element.querySelector(".js-search-list");
    const workingClass = "is-working";

    const toggleWorking = (working) => {
        body.classList.toggle(workingClass, working);
    };

    const fetchResults = async (term) => {
        toggleWorking(true);
        searchList.innerHTML = "";

        if (!term) {
            toggleWorking(false);
            return;
        }

        const href = `${rootUrl}/?s=${encodeURIComponent(term)}`;

        fetch(href)
            .then((response) => response.text())
            .then((html) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, "text/html");

                // Get content
                const content = doc.querySelector(".js-search-results");

                if (content) {
                    toggleWorking(false);
                    searchList.innerHTML = "";
                    searchList.innerHTML = content.innerHTML;
                    const cards = searchList.querySelectorAll(".search-card");
                    gsap.from(cards, {
                        autoAlpha: 0,
                        duration: 0.5,
                        stagger: 0.25,
                    });
                }
                return null;
            });
    };

    searchForm.addEventListener("submit", (e) => {
        e.preventDefault();
        const term = searchInput.value;
        fetchResults(term);
    });

    searchToggle.addEventListener('click', () => {
        searchList.innerHTML = '';
        searchInput.value = '';
    });

    searchTags.forEach(tag => {
        tag.addEventListener('click', () => {
            const term = tag.dataset.term;
            fetchResults(term);
        })
    })
};

export { initSearch as default };
